/* Nola R73 — carga progresiva de la parrilla de colección (todas las anchuras).
   Sustituye el «Ver más / Ver todos» de R27: se muestran todas las tarjetas renderizadas y, al
   acercarse al final, se pide la siguiente página de la paginación de Shopify (conservando
   filtros y orden de la URL) y se añaden sus tarjetas a la misma parrilla, sin duplicados.
   Sin JS se ve la paginación normal (SEO intacto). Tras cada actualización AJAX de Dawn
   (FacetFiltersForm sustituye #ProductGridContainer.innerHTML) se re-inicializa; un contador
   de generación descarta respuestas de una parrilla anterior. Vanilla, sin dependencias. */
(function () {
  var container = document.getElementById('ProductGridContainer');
  if (!container) return;
  var gen = 0, io = null, loading = false;

  function grid() { return document.getElementById('product-grid'); }
  function nextUrl() {
    // Dawn: la flecha «siguiente» es siempre el último elemento de la lista (sus clases --prev/--next están invertidas).
    var a = container.querySelector('.pagination__list > li:last-child > a.pagination__item-arrow');
    return a && a.getAttribute('href') ? a.href : null;
  }
  function keyOf(li) {
    var a = li.querySelector('a[href*="/products/"]');
    return a ? a.getAttribute('href').split('?')[0] : li.id || '';
  }
  function status() {
    var s = container.querySelector('.nb-plp-status');
    if (!s) {
      s = document.createElement('p'); s.className = 'nb-plp-status'; s.setAttribute('role', 'status'); s.setAttribute('aria-live', 'polite');
      var g = grid(); if (g && g.parentNode) g.parentNode.insertBefore(s, g.nextSibling);
    }
    return s;
  }
  function sentinel() {
    var el = container.querySelector('.nb-plp-sentinel');
    if (!el) { el = document.createElement('div'); el.className = 'nb-plp-sentinel'; el.setAttribute('aria-hidden', 'true'); el.style.cssText = 'display:block;width:100%;height:2px;flex:0 0 100%;'; var g = grid(); if (g && g.parentNode) g.parentNode.insertBefore(el, g.nextSibling); }
    return el;
  }
  function loadNext(myGen) {
    var url = nextUrl();
    if (!url || loading) { if (!url) finish(); return; }
    loading = true;
    status().textContent = 'Cargando más productos…';
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (html) {
        if (myGen !== gen) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var srcGrid = doc.getElementById('product-grid'), g = grid();
        if (!srcGrid || !g) throw new Error('sin parrilla');
        var seen = {};
        Array.prototype.forEach.call(g.children, function (li) { seen[keyOf(li)] = 1; });
        Array.prototype.forEach.call(srcGrid.children, function (li) {
          var k = keyOf(li); if (!k || seen[k]) return; seen[k] = 1;
          // Dawn anima las tarjetas al entrar en pantalla con su observador inicial: las nuevas se muestran sin esa clase.
          li.classList.remove('scroll-trigger', 'animate--slide-in', 'scroll-trigger--offscreen');
          g.appendChild(document.importNode(li, true));
        });
        var newPag = doc.querySelector('#ProductGridContainer .pagination-wrapper, #ProductGridContainer nav.pagination');
        var oldPag = container.querySelector('.pagination-wrapper, nav.pagination');
        if (oldPag && newPag) oldPag.replaceWith(document.importNode(newPag, true));
        else if (oldPag) oldPag.remove();
        status().textContent = '';
        loading = false;
        if (!nextUrl()) finish();
        else { var s = sentinel(); if (s.getBoundingClientRect().top < window.innerHeight + 600) loadNext(myGen); }
      })
      .catch(function () {
        if (myGen !== gen) return; // error de una parrilla anterior: no tocar el estado actual
        loading = false;
        if (io) { io.disconnect(); io = null; }
        var s = container.querySelector('.nb-plp-sentinel'); if (s) s.remove();
        status().textContent = '';
        container.classList.remove('nb-plp-js'); // vuelve la paginación normal
      });
  }
  function finish() {
    if (io) { io.disconnect(); io = null; }
    var s = container.querySelector('.nb-plp-sentinel'); if (s) s.remove();
    var st = container.querySelector('.nb-plp-status'); if (st) st.textContent = '';
  }
  function init() {
    gen++; loading = false;
    var myGen = gen;
    if (io) { io.disconnect(); io = null; }
    var g = grid(); if (!g) return;
    // Quitar restos del limitador anterior (si alguna respuesta en caché los trae).
    Array.prototype.forEach.call(g.querySelectorAll('.nb-plp-hidden'), function (li) { li.classList.remove('nb-plp-hidden'); });
    var oldMore = container.querySelector('.nb-plp-more'); if (oldMore) oldMore.remove();
    if (!nextUrl()) return;
    container.classList.add('nb-plp-js'); // oculta la paginación numérica
    if (!('IntersectionObserver' in window)) { container.classList.remove('nb-plp-js'); return; }
    io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) loadNext(myGen); }, { rootMargin: '0px 0px 800px 0px' });
    io.observe(sentinel());
    // Respaldo: comprobación por scroll (algunos contenedores no notifican al observador).
    if (!window.__nbPlpScroll) {
      window.__nbPlpScroll = true;
      var tick = false;
      window.addEventListener('scroll', function () {
        if (tick) return; tick = true;
        requestAnimationFrame(function () {
          tick = false;
          var s = container.querySelector('.nb-plp-sentinel');
          if (s && s.getBoundingClientRect().top < window.innerHeight + 800) loadNext(gen);
        });
      }, { passive: true });
    }
  }
  init();
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      for (var j = 0; j < muts[i].addedNodes.length; j++) {
        var n = muts[i].addedNodes[j];
        if (n.nodeType === 1 && (n.id === 'product-grid' || (n.querySelector && n.querySelector('#product-grid')))) { init(); return; }
      }
    }
  }).observe(container, { childList: true });
})();
